import { zhCN as t } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/locale/zh-CN.js";
const a = {
  name: "zh-CN",
  locale: t
}, o = a;
export {
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/locales/date/zhCN.js
// module id = 54
// module chunks = 67